
import RelatedStories from './relatedstories.js';
import {useLocation} from 'react-router-dom';


export default function Tags(match){
    const location = useLocation()
    const tg = location.state?.tagslug
    const tgn = location.state?.tagname
    /*const { newsitem, error, loading } = useRelatedStoriesList("stone bwoy")*/
    //console.log(tg)
    return(
        <>
        <div style={{padding:"10px 0px 15px 0px", fontWeight:"100", fontStyle:"italic", fontSize:"18px"}}>Showing stories related to : <span style={{color:"#333333", fontStyle:"normal", fontWeight:"600"}}>{tgn}</span></div>
        <RelatedStories tagged={true} tags={tg} />
        </>
 
  )

}